import n from "./SwitchButton.vue2.mjs";
import { resolveComponent as t, openBlock as r, createBlock as a, withCtx as p, createElementVNode as i, normalizeClass as o, renderSlot as c, toDisplayString as f } from "vue";
import u from "../../_virtual/_plugin-vue_export-helper.mjs";
function d(e, m, b, g, v, C) {
  const l = t("RadioGroupOption");
  return r(), a(l, {
    value: e.value,
    disabled: e.disabled,
    class: "ml-0.5 first:ml-0"
  }, {
    default: p(({ checked: s }) => [
      i("button", {
        class: o(["group flex items-center whitespace-nowrap rounded-md px-2 py-1.5 text-sm font-medium focus:outline-none focus-visible:ring-2 focus-visible:ring-primary-500 focus-visible:ring-offset-2 focus-visible:ring-offset-zinc-100 dark:focus-visible:ring-offset-zinc-850 lg:pl-2.5 lg:pr-3.5", s ? e.spec.checkedButtonClasses : ""]),
        type: "button"
      }, [
        c(e.$slots, "icon", {
          class: o(["mr-2 size-4", s ? e.spec.checkedIconClasses : e.spec.iconClasses])
        }),
        i("span", {
          class: o(s ? e.spec.checkedLabelClasses : e.spec.labelClasses)
        }, f(e.label), 3)
      ], 2)
    ]),
    _: 3
  }, 8, ["value", "disabled"]);
}
const w = /* @__PURE__ */ u(n, [["render", d]]);
export {
  w as default
};
//# sourceMappingURL=SwitchButton.vue.mjs.map
